<script lang="ts">
  import { _ } from 'svelte-i18n';
  
  // Props
  export let countryCode: string = '+31';
  export let phoneNumber: string = '';
  export let label: string = '';
  export let placeholder: string = '';
  export let required: boolean = false;
  
  // Country options
  const countryOptions = [
    { code: '+31', flag: '🇳🇱', country: 'Netherlands' },
    { code: '+32', flag: '🇧🇪', country: 'Belgium' },
    { code: '+49', flag: '🇩🇪', country: 'Germany' },
    { code: '+44', flag: '🇬🇧', country: 'United Kingdom' },
    { code: '+33', flag: '🇫🇷', country: 'France' }
  ];
</script>

<div>
  {#if label}
    <label for="phoneInput">{label}</label>
  {/if}
  <div class="grid no-wrap">
    <div>
      <select bind:value={countryCode}>
        {#each countryOptions as option}
          <option value={option.code}>{option.flag} {option.code}</option>
        {/each}
      </select>
    </div>
    <div>
      <input 
        id="phoneInput"
        type="tel" 
        bind:value={phoneNumber} 
        {required}
        {placeholder}
      />
    </div>
  </div>
</div> 